/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    RETRY_CALCULATE_SHIPPING_ATTEMPT,
    CLEAR_CALCULATE_SHIPPING_ATTEMPT,
    UPDATE_CALCULATE_SHIPPING_APPLIED,
    CALCULATE_CART,
    CALCULATE_CART_COMPLETED,
    CALCULATE_SERVICE_CART,
    CALCULATE_SERVICE_CART_COMPLETED,
    CALCULATE_SHIPPING_PAYMENT_METHOD_CHANGED,
    CALCULATE_SHIPPING_PAYMENT_METHOD_CHANGED_COMPLETED,
} from './CalculateCart-ActionTypes';

export const calculateCart = () => ({
    type: CALCULATE_CART,
});

export const calculateCartComplete = () => ({
    type: CALCULATE_CART_COMPLETED,
});

export const updateRetryCalculateShippingAttempt = () => ({ type: RETRY_CALCULATE_SHIPPING_ATTEMPT });

export const clearCalculateShippingAttempt = () => ({ type: CLEAR_CALCULATE_SHIPPING_ATTEMPT });

export const calcualteShippingPaymentMethodIsChanged = () => ({ type: CALCULATE_SHIPPING_PAYMENT_METHOD_CHANGED });

export const calcualteShippingPaymentMethodIsChangedCompleted = () => ({ type: CALCULATE_SHIPPING_PAYMENT_METHOD_CHANGED_COMPLETED });

export const updateCalculateShippingApplied = (data) => ({
    type: UPDATE_CALCULATE_SHIPPING_APPLIED,
    data,
});

export const cartServiceCalculateCart = () => ({
    type: CALCULATE_SERVICE_CART,
});

export const cartServiceCalculateCartCompleted = () => ({
    type: CALCULATE_SERVICE_CART_COMPLETED,
});
